import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { cn } from '@/frontend/utils';
export type SectionNavItem = {
  id: number;
  title: string;
};
type StickyNavbarProps = {
  sections: SectionNavItem[];
  activeSectionId: number;
  sectionRefs: React.RefObject<(HTMLDivElement | null)[]>;
};
export function StickyNavbar(t0) {
  const $ = _c(11);
  const {
    sections,
    activeSectionId,
    sectionRefs
  } = t0;
  let t1;
  if ($[0] !== sectionRefs) {
    t1 = id => {
      const section = sectionRefs.current?.[id];
      if (section) {
        window.scrollTo({
          top: section.getBoundingClientRect().top + window.scrollY - 40,
          behavior: "smooth"
        });
      }
    };
    $[0] = sectionRefs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  let t2;
  if ($[2] !== activeSectionId || $[3] !== handleClick || $[4] !== sections) {
    let t3;
    if ($[6] !== activeSectionId || $[7] !== handleClick) {
      t3 = section_0 => <button type="button" key={section_0.id} onClick={() => handleClick(section_0.id)} className={cn("block rounded-lg px-3 py-2 text-left font-medium text-slate-600 text-sm hover:bg-slate-50", activeSectionId === section_0.id && "font-bold text-slate-900")}>{section_0.title}</button>;
      $[6] = activeSectionId;
      $[7] = handleClick;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = sections.map(t3);
    $[2] = activeSectionId;
    $[3] = handleClick;
    $[4] = sections;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <nav className="flex flex-col gap-2">{t2}</nav>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}